import { render, staticRenderFns } from "./QuestionbankType.vue?vue&type=template&id=5ebc25b2&"
import script from "./QuestionbankType.vue?vue&type=script&lang=js&"
export * from "./QuestionbankType.vue?vue&type=script&lang=js&"
import style0 from "./QuestionbankType.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports